<template>
  <transition
    appear
    name="accordion"
    @enter="startTransition"
    @leave="endTransition"
  >
    <div
      v-if="isActive || expandAll"
      :id="`content-${ index }`"
      class="accordion__content"
      role="region"
      :aria-labelledby="`Accordion${ index }`"
    >
      <slot :item="item" />
    </div>
  </transition>
</template>

<script>

/**
 * Vue: accordion (accordion)
 * -----------------------------------------------------------------------------
 * Accordion.
 *
 */

export default {
  name: 'AccordionItem',

  props: {
    expandAll: {
      type: Boolean,
      default: false,
    },

    item: {
      type: Object,
      default: () => ({}),
    },

    index: {
      type: Number,
      default: 1,
    },

    isActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    startTransition(el) {
      if (el.scrollHeight === 0) {
        el.style.height = 'auto'

        return
      }

      el.style.height = `${el.scrollHeight}px`
    },

    endTransition(el) {
      el.style.height = ''
    },
  },
}
</script>
